import { CheckCircle } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 22
  },
  subTitle: {
    fontSize: 16
  },
  controls: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(3)
  }
}));

const ImageMap = {
  success: (
    <CheckCircle
      fontSize="medium"
      sx={{ fontSize: 40, my: 3 }}
      color="success"
    />
  ),
  404: 'https://rayo.s3.us-west-1.amazonaws.com/Purple+And+Pink+Illustration+Error+404+Facebook+Post+(3).png',
  500: 'https://rayo.s3.us-west-1.amazonaws.com/Purple+And+Pink+Illustration+Error+404+Facebook+Post+(4).png',
  403: 'https://rayo.s3.us-west-1.amazonaws.com/Purple+And+Pink+Illustration+Error+404+Facebook+Post+(1).png'
};

const ResultNode = ({ status }) => {
  const imageRoute = ImageMap[status];
  return typeof imageRoute === 'string' ? (
    <img
      sx={{ height: 260, my: { xs: 5, sm: 10 } }}
      alt="error response"
      style={{ borderRadius: `${16}px` }}
      src={imageRoute}
    />
  ) : (
    imageRoute
  );
};

ResultNode.propTypes = {
  status: PropTypes.oneOf([...Object.keys(ImageMap)])
};

function Result({ status, extra, title, subTitle, withImage = true }) {
  const classes = useStyles();

  return (
    <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ borderRadius: '16px' }}
      >
        {withImage && <ResultNode status={status} />}
      </Box>
      <Typography variant="h3" paragraph className={classes.title}>
        {title}
      </Typography>
      {subTitle && (
        <Typography
          sx={{ color: 'text.secondary' }}
          className={classes.subTitle}
        >
          {subTitle}
        </Typography>
      )}

      {extra && <div className={classes.controls}>{extra}</div>}
    </Box>
  );
}

Result.propTypes = {
  status: PropTypes.oneOf(['success', 'error', 'warning', '403', '404', '500'])
    .isRequired,
  extra: PropTypes.node,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  withImage: PropTypes.bool
};

export default Result;
